export const DOWNLOAD_LIMIT_PPTX_ONEPAGER = 100;
export const DOWNLOAD_LIMIT_XLSX_CONTACTS = 500;
// TD-2703: company-profiles bulk XLSX ("Download company profiles as XLSX"). One
// row per company, so it takes the same 500-company cap as the contacts XLSX.
export const DOWNLOAD_LIMIT_XLSX_PROFILES = 500;

// Per-download list cap, not the subscription allowance (`limitReached`,
// DOWNLOAD_LIMIT_EXCEEDED_CODE). Inclusive: a list of exactly `limit` companies
// downloads, one more does not, the same "up to" rule the in-app agent states.
// The backend checks only the allowance and has no list-size cap yet (planned
// under TD-2591), so this check is the only enforcement of the cap.
export const exceedsListCap = (count, limit) => count > limit;

// `canExclude: false` where the viewer cannot exclude companies (Team feedback
// recipients): only the colleague who shared the list can shorten it.
export const listCapTooltip = (limit, { canExclude = true } = {}) =>
  canExclude
    ? `Up to ${limit} companies per download. Exclude companies to activate the download.`
    : `Up to ${limit} companies per download. The colleague who shared this list can exclude companies.`;

// BE error code returned on a 403 from bulk-export endpoints when the request
// would push the user over their download limit. Source: lambdas-auxbe/lib/
// downloadTracking.js#buildLimitExceededBody. Hosts surface the rich envelope
// in the bulk-export modal's insufficient state via reopenForLimitExceeded.
export const DOWNLOAD_LIMIT_EXCEEDED_CODE = 'DOWNLOAD_LIMIT_EXCEEDED';

// What the user reads once the subscription allowance is used up: the Downloads counter and
// the exports that report a refusal themselves (the shareholder graph) say the same thing.
export const DOWNLOAD_LIMIT_REACHED_MESSAGE = 'Download Limit Reached';
